<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="A"><a href="#/Contents#ack">ACKNOWLEDGMENTS</a></p>
<p class="para_1">I would like to show my gratitude to the following ski resorts and organizations that helped in the creation of this book: Holiday Mountain, Hunter Mountain, Belleayre Mountain, Rip Van Winkle Ski Club, Woodstock Historical Society, and Norway Ski Club.</p>
<p class="para">I am also grateful to the many individuals who shared their lives and photographic archives: John M. Ham, Edith Brody, Joe Strauss, Karl and Margot Plattner, Phil and Anne Davenport, Robert and Valerie Konefal, Steve Witte, Dean Schambach, Laura Kluthe Iwanski, Howard and Elinor Lindemann, Jerry Fielding, Bonnie Hinkley, Gary Hinkley, Bea Hinkley, Carol Tomesetti, Breeda O’Callaghan, Nell Boucher, Hermann Amsz, Anthony and Lynette Liberetore, Richard Heppner, Milo Stewart Jr., David Slutzky, Rick Barthel, Jerry Fielding.</p>
<p class="para">I especially want to thank Bernadette Quinn and Ilene Mark for their hard work and encouragement.</p>
<p class="para">A special thanks goes to Mohonk Mountain House Archives, which will be referred to in the caption credits as MMHA. Unless otherwise noted, all images appear courtesy of the Quinn collection.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?342d941e